export const messages = {
  en: {
    adminRoom: {
      search: {
        title: 'Search Conditions',
        roomNum: 'Room Number Building-Unit-Room',
        ownerName: 'Owner Name',
        ownerTel: 'Owner Phone',
        state: 'Select State',
        roomType: 'Select Room Type'
      },
      list: {
        title: 'Community Rooms'
      },
      table: {
        room: 'Room',
        community: 'Community',
        floor: 'Floor',
        floorUnit: 'F',
        owner: 'Owner',
        type: 'Type',
        area: 'Area',
        areaUnit: 'm²',
        rent: 'Rent',
        state: 'State',
        validDate: 'Valid Date',
        member: 'Member',
        car: 'Car',
        ownerRoom: 'Owner Room',
        contract: 'Contract'
      },
      fetchError: 'Failed to fetch room data'
    }
  },
  zh: {
    adminRoom: {
      search: {
        title: '查询条件',
        roomNum: '房屋编号 楼栋-单元-房号',
        ownerName: '业主名称',
        ownerTel: '业主电话',
        state: '请选择状态',
        roomType: '请选择房屋类型'
      },
      list: {
        title: '园区房屋'
      },
      table: {
        room: '房屋',
        community: '园区',
        floor: '楼层',
        floorUnit: '层',
        owner: '业主',
        type: '类型',
        area: '建筑/室内面积',
        areaUnit: '平方米',
        rent: '租金',
        state: '房屋状态',
        validDate: '有效期',
        member: '业主成员',
        car: '业主车辆',
        ownerRoom: '业主房屋',
        contract: '房屋合同'
      },
      fetchError: '获取房屋数据失败'
    }
  }
}